import { Platform } from 'react-native';
import storage from './storage';

// Production API endpoint.
const WORKER_URL = 'https://api.4399999.xyz';

const BASE_URL = Platform.OS === 'web'
    ? `${WORKER_URL}/api`
    : `${WORKER_URL}/api`;

const REQUEST_TIMEOUT_MS = 10000;

console.log('API Service initialized with BASE_URL:', BASE_URL);

function normalizePath(path) {
    if (!path) return '';
    return path.startsWith('/') ? path : `/${path}`;
}

function createHttpError(message, status, data) {
    const error = new Error(message);
    error.response = { status, data };
    return error;
}

async function parseResponseData(response) {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        try {
            return await response.json();
        } catch (error) {
            return null;
        }
    }

    const text = await response.text();
    return text || null;
}

async function request(method, path, payload, config = {}) {
    const token = await storage.getItem('token');
    const headers = {
        Accept: 'application/json',
        ...(config.headers || {}),
    };

    let body;
    if (payload !== undefined) {
        const isStringBody = typeof payload === 'string';
        const isFormDataBody = typeof FormData !== 'undefined' && payload instanceof FormData;

        if (isStringBody || isFormDataBody) {
            body = payload;
        } else {
            headers['Content-Type'] = 'application/json';
            body = JSON.stringify(payload);
        }
    }

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeoutId = controller
        ? setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS)
        : null;

    try {
        const response = await fetch(`${BASE_URL}${normalizePath(path)}`, {
            method,
            headers,
            body,
            signal: controller?.signal,
        });

        const data = await parseResponseData(response);

        if (!response.ok) {
            const message =
                data && typeof data === 'object' && data.message
                    ? data.message
                    : `请求失败，状态码 ${response.status}`;
            throw createHttpError(message, response.status, data);
        }

        return {
            data,
            status: response.status,
            headers: response.headers,
        };
    } catch (error) {
        if (error?.name === 'AbortError') {
            throw createHttpError('请求超时', 0, { message: '请求超时' });
        }

        if (error?.response) {
            throw error;
        }

        throw createHttpError(error?.message || '网络错误', 0, {
            message: error?.message || '网络错误',
        });
    } finally {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    }
}

const api = {
    get: (path, config) => request('GET', path, undefined, config),
    post: (path, data, config) => request('POST', path, data, config),
    put: (path, data, config) => request('PUT', path, data, config),
    delete: (path, config) => request('DELETE', path, undefined, config),
};

export default api;
